import React from "react";
import { TableUi } from "../../components/table.ui";
import { useQuery } from "react-query";
import { useAuth } from "../../middleware/auth.middleware";

export const RejeteGYMSPA = () => {
  const { role } = useAuth()
  const _gymspa = useQuery(['gymspa', role]);


  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src='/assets/employe.png'
          />
        </div>
      ),
    },
    {
      Header: "Employé",
      accessor: "userId",
      Cell: ({ cell }) => (
        <div className="">
          {
            cell.row.values.userId.prenom.charAt(0).toUpperCase() + cell.row.values.userId.prenom.slice(1) + ' ' + cell.row.values.userId.nom
          }
        </div>
      ),
    },
    {
      Header: "Forfait",
      accessor: "forfait",
    },
    {
      Header: "Type",
      accessor: "typeGS",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Mode de paiement",
      accessor: "methodePaiement",
    }
  ];

  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2">
        <div className="flex flex-row text-center justify-between">
          <div className="flex flex-col text-left">
          <h1 className="text-xl ">Les informations rejetées</h1>
            
          </div>
        </div>
      </div>
      {
        _gymspa.isSuccess && _gymspa?.data?.data?.rejete?.length !== 0
          ? <TableUi columns={COLUMNS} data={_gymspa?.data?.data?.rejete} colsHidden={["_id"]} />
          : <p className="text-gray-600 text-sm">Aucune information trouvée</p>

      }

    </div>
  );
};
